import { Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import * as jQuery from "jquery";
import { PerfilService } from "src/app/services/perfil.service";
import { ActividadesService } from "src/app/services/actividades.service";
import { environment } from "src/environments/environment";

import { AlertController } from "@ionic/angular";
import { ActivatedRoute } from "@angular/router";
import { multi } from "../../estadisticas/data";
import { ToastService } from "src/app/services/toast.service";
import { GlobalsService } from "src/app/api/globals.service";

@Component({
  selector: "app-estudiantes-comp",
  templateUrl: "./estudiantes-comp.component.html",
  styleUrls: ["./estudiantes-comp.component.scss"],
})
export class EstudiantesCompComponent implements OnInit {
  @Input() public curso: any;
  @Input() public perfil: any;
  @Input() public data_estudiantes: any = [];
  @Input() public data_profesores: any;
  @Input() public data_calf: any = [];
  @ViewChild("observacionRef") observacionRef: ElementRef;
  @ViewChild("calificacionRef") calificacionRef: ElementRef;
  ejercicioActivid = [];
  currentIndex = 0;
  resultado = 0;
  selectedStudent: any = null;
  actividades = [];
  editingIndex: number = -1;
  avatar = "assets/imagenes/sistema/user1.png";
  data_estudiante: any = [];
  activities: any;
  deleteId = 0;
  search_op: number = 0;
  ID: number;
  AUTH_KEY: string;
  displayUserData: any;
  usersList: any = [];
  todos_cursos: any = [];
  activCurso: any = [];
  email_list: any = [];
  tiempo_promedio: any;
  correoFrom;
  Tiempo_total: any;
  emailForm: FormGroup;
  argumentos;
  ids: any = [];
  isSubmitted: boolean = false;
  data_exercise = {
    name: "",
    activitie: {},
  };
  studern_select: any;
  public searchControlUsers: FormControl;
  dataLoaded = false;
  actividadIndex = 0;
  imgUrl = "";
  observacion: string;
  isDetailActivity = false;
  idActividadNow = 0;
  idEstudianteNow = 0;
  ismobile = false;

  constructor(
    public globalsService: GlobalsService,
    private cursosService: CursosService,
    private authService: AuthService,
    private perfilService: PerfilService,
    public actividadesService: ActividadesService,
    public formBuilder: FormBuilder,
    public alertController: AlertController,
    private activeRoute: ActivatedRoute,
    public toastService: ToastService
  ) {
    this.ismobile = globalsService.isMobile;
    this.imgUrl = environment.host + "/web/";
    this.activCurso = [];
    this.searchControlUsers = new FormControl();
    this.argumentos = this.activeRoute.snapshot.paramMap.get("id_curso");
    this.emailForm = this.formBuilder.group({
      correo: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[A-Z0-9a-z\\._%+-]+@([A-Za-z0-9-]+\\.)+[A-Za-z]{2,4}$"
          ),
        ],
      ],
    });
  }

  ngOnInit() {
    this.loadUserData();
    this.getCalifica();
  }

  submitForm() {
    this.isSubmitted = true;
    if (!this.emailForm.valid) {
      console.log("Please provide all the required values!");
      return false;
    } else {
      if (this.email_list.indexOf(this.emailForm.value.correo) === -1) {
        this.sendEmailYii();
        this.addEmailListUser(this.emailForm.value.correo);
      } else {
        this.alertMessage("El correo ya está en su lista");
      }
    }
  }

  onSelect(event) {
    console.log(event);
  }

  sendEmailYii(): Promise<any> {
    return new Promise((resolve) => {});
  }

  getCalifica() {
    this.activCurso = [];
    this.cursosService
      .getCalfStudents(this.AUTH_KEY, this.curso.id, this.ID)
      .subscribe(
        (calfTeach: any) => {
          if (calfTeach) {
            this.activCurso =
              this.perfil == "student"
                ? calfTeach.calificaciones.filter(
                    (x) => x.id_estudiante == this.ID
                  )
                : calfTeach.calificaciones;
          }
        },
        (error) => {
          console.error("Error al obtener datos de calificaciones:", error);
        }
      );

    this.validDate();
  }

  validDate() {
    if (this.activCurso.length == 0) {
      this.dataLoaded = true;
    }
  }
  getDetail(id_actividad, id_estudiante, nota) {
    if (nota != "No Realizada") {
      this.isDetailActivity = true;
      this.idActividadNow = id_actividad;
      this.idEstudianteNow = id_estudiante;
    }
    console.log(
      "🚀 ~ EstudiantesCompComponent ~ getDetail ~ id_actividad,id_estudiante:",
      id_actividad,
      id_estudiante
    );
  }

  addEmailListUser(email: string) {
    let params = {
      email: email,
      id_curso: this.argumentos,
    };
    this.cursosService
      .addEmailListUserCurso(this.ID, this.AUTH_KEY, params)
      .subscribe((response) => {
        let list: any = response;
        if (list.auth_key && list.save) {
          this.email_list.push(this.emailForm.value.correo);
          this.emailForm.reset();
        }
      });
  }

  getEmailListUser() {
    this.cursosService
      .getEmailListUser(this.ID, this.AUTH_KEY)
      .subscribe((response) => {
        let list: any = response;
        if (list.auth_key) {
          let lista: any = list.result;
          lista.forEach((element) => {
            this.email_list.push(element.correo);
          });
        }
      });
  }

  get errorControl() {
    return this.emailForm.controls;
  }
  loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        if (res) {
          if (!this.displayUserData) {
            this.displayUserData = res;
            this.ID = this.displayUserData?.id;
            this.AUTH_KEY = this.displayUserData?.auth_key;
            resolve(true);
          }
        }
      });
    });
    this.todos_cursos = [];
    promise.then((success) => {
      if (success) {
        let usersList = JSON.stringify(this.data_profesores);
        console.log("data_profesores: ", usersList);

        this.searchControlUsers.valueChanges
          .pipe(debounceTime(700))
          .subscribe((search) => {
            // this.searching = false;
            let searchC: any = this.searchControlUsers;

            this.setFilteredItems(search);
          });
        let promise2 = new Promise((resolve) => {
          this.actividadesService
            .getAllActividadesCursos(this.AUTH_KEY, this.curso.id)
            .subscribe((response) => {
              console.log("getAllActividadesCursos: ", response);
              let cursos1: any = [];
              cursos1 = response;
              cursos1.forEach((element, i, array) => {
                this.todos_cursos.push({
                  id: element.data.id,
                  nombre: element.data.titulo,
                  tipo: 1,
                });
                if (i == array.length - 1) {
                  resolve(true);
                }
              });
            });
        });

        promise2.then((success2) => {
          if (success2) {
            if (this.data_estudiantes) {
              this.data_estudiantes.forEach((element) => {
                this.ids.push(element.id_user);
                if (element.id_user == this.ID) {
                  this.data_estudiante.push(element);
                }
              });
            }

            this.cursosService
              .getActividadCurso(this.ID, this.curso.id, this.AUTH_KEY)
              .subscribe((res: any) => {
                let cursos2: any = [];
                cursos2 = res;
                cursos2.forEach((element, i, array) => {
                  this.todos_cursos.push({
                    id: element.data[0].id,
                    nombre: element.data[0].nombre_actividad,
                    tipo: 2,
                  });
                  if (i == array.length - 1) {
                    console.log("this.todos_cursos: ", this.todos_cursos);
                  }
                });
              });
          }
        });
      }
      this.getEmailListUser();
    });
  }

  opcionCange() {
    let extBtn = document.getElementById("estudiante-add-btn");
    extBtn.click();
  }

  activar(id) {
    this.search_op = id;
  }

  setFilteredItems(search) {
    console.log(search);
    this.cursosService
      .getStudents(this.ID, this.AUTH_KEY, search)
      .subscribe((response) => {
        let list: any = response;
        if (!list.error) {
          this.usersList = list.users;
          console.log("list: ", this.usersList);
        }
      });
  }
  isChekked(id): boolean {
    let check = false;
    this.data_estudiantes.forEach((element) => {
      if (element.id_user == id) {
        check = true;
      }
    });
    return check;
  }

  selectUsers() {
    this.data_estudiantes.splice(0, this.data_estudiantes.length);
    let checkboxs = jQuery(".chkbx-hide");
    let ids: any = this.ids;
    // for(let i = 0; i < checkboxs.length; i++){
    //   if(jQuery(checkboxs[i]).is(':checked')){
    //     let idUser = ( jQuery(checkboxs[i]).data('id'));
    //     ids.push(idUser);
    //   }
    // }
    this.allDataUser(ids).then((success) => {
      if (success) {
        let data = success;
        console.log("success: ", data);
        data.forEach((element, i, array) => {
          this.data_estudiantes.push(element);
          if (i == array.length - 1) {
            console.log("data_estudiantes: ", this.data_estudiantes);
            this.sendUsersToYii(ids);
          }
        });
      }
    });
  }

  sendUsersToYii(ids) {
    let params = {
      users_id: ids,
      id_curso: this.argumentos,
    };
    this.cursosService
      .addEmailListUsersCurso(this.ID, this.AUTH_KEY, params)
      .subscribe((response) => {
        let list: any = response;
        if (list.auth_key) {
          console.log("LIST: ", list);
        }
      });
  }

  checkUsers(el) {
    let checkbox = jQuery(el.target);
    let id = jQuery(checkbox).data("id");
    console.log("checkUsers: ", id);
    let img = jQuery(checkbox).closest(".card-box").find(".img-chk");
    if (jQuery(checkbox).is(":checked")) {
      jQuery(img).addClass("active");
      this.ids.push(id);
      console.log("this.ids.push(id);: ", this.ids);
    } else {
      jQuery(img).removeClass("active");
      this.ids.forEach((element, i, array) => {
        if (element == id) {
          this.ids.splice(i, 1);
          console.log("this.ids.push(id);: ", this.ids);
        }
      });
    }
  }

  allDataUser(ids = null): Promise<any> {
    return new Promise((resolve) => {
      if (ids == null || ids.length == 0) {
        resolve(false);
      } else {
        this.perfilService
          .getPerfilByIds(this.ID, this.AUTH_KEY, ids)
          .subscribe((res: any) => {
            let respuesta: any;
            respuesta = JSON.parse(res);
            if (respuesta.auth_key) {
              resolve(respuesta.data);
            } else {
              //logout
              resolve(false);
            }
          });
      }
    });
  }

  getUserImage(imagenes, imgDefault = false) {
    let imagen: string = null;
    if (imgDefault) {
      imagen = "assets/imagenes/profesor.png";
    }
    if (imagenes)
      if (imagenes.length > 0)
        imagenes.forEach((element) => {
          if (element.tipo == 2) {
            imagen = environment.host + "/" + element.url + element.name;
          }
        });
    return imagen;
  }

  deleteUser(id) {
    let element = document.getElementById("delete-user" + id);
    jQuery(element).fadeOut();
    this.data_estudiantes.forEach((element, i, array) => {
      if (element.id_user == id) {
        this.data_estudiantes.splice(i, 1);
      }
    });
    this.ids.forEach((element, i, array) => {
      if (element == id) {
        this.ids.splice(i, 1);
      }
      if (i == array.length - 1) {
        this.selectUsers();
      }
    });
  }

  alertDelete(id) {
    let elements = document.getElementsByClassName("delete-user");
    jQuery(elements).fadeOut();
    if (this.deleteId != id) {
      this.deleteId = id;
      let element = document.getElementById("delete-user" + id);
      jQuery(element).fadeIn();
    } else {
      this.deleteId = 0;
    }
  }

  async alertMessage(message: string) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: message,
      buttons: ["Aceptar"],
    });

    await alert.present();
  }
  addToSend(email: string) {
    this.sendMessage(email);
  }
  async sendMessage(email: string) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "¿Desea enviar la invitación?",
      subHeader: "",
      message: "Correo detino: " + email,
      buttons: [
        {
          text: "Aceptar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Enviando...");
            this.sendMessageToYii(email);
          },
        },
        {
          text: "Cancelar",
          handler: () => {
            console.log("Cancelado");
          },
        },
      ],
    });

    await alert.present();
  }

  sendMessageToYii(email) {
    let params = {
      email: email,
      id_curso: this.argumentos,
    };
    this.cursosService
      .addEmailListUserCurso(this.ID, this.AUTH_KEY, params)
      .subscribe((response) => {
        let list: any = response;
        //console.log('list: ',list);
        if (list.auth_key && list.save) {
          this.email_list.push(this.emailForm.value.correo);
          this.emailForm.reset();
        }
      });
  }

  unlinkUser(data: any) {
    this.presentAlertConfirm("¿Desea eliminar el Estudiante del curso?").then(
      (res) => {
        if (res) {
          let params = {
            auth_key: this.AUTH_KEY,
            id_user_curso: this.ID,
            id_user: data.id_estudiante,
            id_curso: this.curso.id,
            tipo: "Estudiante",
          };
          this.cursosService.unlikUserCurso(params).subscribe((response) => {
            this.toastService.presentToast(
              "Se eliminó el Estudiante del curso"
            );
            setTimeout(() => {
              window.location.reload();
            }, 200);
          });
        }
      }
    );
  }

  async presentAlertConfirm(message: string): Promise<boolean> {
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        header: "Confirmar",
        message: message,
        buttons: [
          {
            text: "Cancelar",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              resolve(false);
            },
          },
          {
            text: "Proceder",
            handler: () => {
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  isNumber(value: any): boolean {
    return !isNaN(value);
  }

  goBack() {
    this.isDetailActivity = false;
    this.getCalifica();
  }
}
